'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'repeat';
var width = 512;
var height = 512;
var aliases = [128257];
var unicode = 'f363';
var svgPathData = 'M392 208l8-8c52.7-52.7 87.4-87.4 104-104-16.6-16.6-51.3-51.3-104-104l-8-8-40 0 0 88-352 0 0 216 48 0 0-168 304 0 0 88 40 0zm8-75.9l0-72.2 36.1 36.1-36.1 36.1zM160 440l352 0 0-216-48 0 0 168-304 0 0-88-40 0-8 8c-52.7 52.7-87.4 87.4-104 104 16.6 16.6 51.3 51.3 104 104l8 8 40 0 0-88zM75.9 416l36.1-36.1 0 72.2-36.1-36.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRepeat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;